import React from 'react';
import StatisticContainer from '@src/containers/Statistic';
import PermissionGate from '@src/components/PermissionGate';
import { PERMISSIONS } from '@src/constants';

const Statistic = () => (
  <PermissionGate requiredPermissions={[PERMISSIONS.VIEW_STATS]}>
    <StatisticContainer />
  </PermissionGate>
);

export default Statistic;
